'use strict';

angular.module('amexReconciliationApp')
  .component('unmatchedReceiptTile', {
    bindings: {
      receipt: '<',
      onDelete: '&',
      onSuccess: '&',
      transactions: '<'
    },
    templateUrl: 'scripts/views/components/unmatched-receipt-tile.html',
    controller: function (ReceiptService,
                          ReceiptRepository,
                          TransactionSearchModel,
                          SiteConfigModel) {
      var self = this;

      self.isReceiptViewable = ReceiptService.isReceiptViewable;
      self.editReceiptDetailsFlag = false;

      self.setEditDetailsFlag = function() {
        self.editReceiptDetailsFlag = true;
      };

      self.unsetEditDetailsFlag = function() {
        self.editReceiptDetailsFlag = false;
      };
      
      self.editDetails = function() {
        return self.editReceiptDetailsFlag;
      };

      self.showMatchButton = function () {
        return !self.editDetails();
      };

      self.togglePopover = function togglePopover() {
        self.toggle = !self.toggle;
      };

      self.deleteReceipt = function deleteReceipt() {
        ReceiptRepository.deleteReceipt(self.receipt)
          .then(function (receipt) {
            return self.onDelete({receipt: receipt});
          })
          .then(function () {
            self.toggle = false;
          });
      };

      self.showDelete = function () {
        return (
          SiteConfigModel.deleteReceiptEnabledForRole(TransactionSearchModel.roleName())
        );
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/unmatchedReceiptTile.js
// module id = 503
// module chunks = 0